import { UPDATE_PROFILE } from '@storeOld/actions'
import {
  ChangesSavedNotification,
  GeneralErrorNotification,
} from '@storeOld/reducers/notification'
import { call, delay, put } from 'redux-saga/effects'

import { NestClient } from '@/nest'
import type { InternalAccountActions } from '../actions'
import type { AccountUpdateResult } from '../types'

const REQUEST_TIMEOUT = 1000

export function* updateRequest({
  payload,
}: ReturnType<typeof InternalAccountActions.updateRequest>) {
  yield delay(REQUEST_TIMEOUT)

  try {
    const updated: AccountUpdateResult = yield call(
      NestClient.account.update,
      payload
    )
    yield put({ type: UPDATE_PROFILE, payload: updated })
    yield put(ChangesSavedNotification)
  } catch (e) {
    console.error('Error while account update', e)
    yield put(GeneralErrorNotification)
  }
}
